import { PanelLeftCloseIcon } from "lucide-react";

import { IgIconButton } from "@intelligems/ig-theme/IgIconButton";
import { IgTooltip } from "@intelligems/ig-theme/IgTooltip";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useDispatch } from "@src/store";
import { setSideNavCollapsed } from "@src/store/slices/appSettings";

export const SideNavCollapseControl = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <Grid>
      <IgTooltip title={"Collapse Navigation"}>
        <IgIconButton
          aria-label="Collapse navigation"
          onClick={() => {
            dispatch(setSideNavCollapsed());
          }}
        >
          <PanelLeftCloseIcon size={16} />
        </IgIconButton>
      </IgTooltip>
    </Grid>
  );
};
